/**
 * Punto de entrada.
 *
 * El orden de los `import` de CSS es NORMATIVO y está fijado en TOKENS.md §2:
 * tokens → foundations → brand → ui → patterns → sobrescritura de marca →
 * CSS propio. Cambiarlo rompe la marca: `marca-sigfisc.css` gana por orden de
 * aparición, no por especificidad, porque redefine variables en `:root`.
 */
import '@mpfn/tokens/css'
import '@mpfn/styles/foundations.css'
import '@mpfn/brand/styles.css'
import '@mpfn/ui/styles.css'
import '@mpfn/patterns/styles.css'
import './styles/marca-sigfisc.css'
import './styles/sigfisc.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { App } from './App.js'
import { ErrorApi } from './api/cliente.js'

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      // Un 401 o un 403 no mejoran reintentando: el primero exige iniciar
      // sesión y el segundo no va a cambiar de opinión.
      retry: (intentos, error) => {
        if (error instanceof ErrorApi && (error.estado === 401 || error.estado === 403)) return false
        return intentos < 2
      },
      staleTime: 30_000,
      refetchOnWindowFocus: true,
    },
    mutations: { retry: false },
  },
})

// `UI-14`: el selector de tema no se ofrece hasta validar el oscuro completo
// con la paleta sobrescrita. Hasta entonces se fija claro explícitamente, en
// vez de dejarlo a merced de la preferencia del sistema.
document.documentElement.setAttribute('data-theme', 'light')
document.documentElement.lang = 'es-PE'

const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('Falta el nodo #raiz en index.html.')

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={cliente}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
